const adminTypeOptions = [
  { name: 'platform', label: 'login.types.platform' },
  { name: 'establishment', label: 'login.types.establishment' },
];

export default adminTypeOptions;
